import styled from "styled-components";

const InnerList = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  width: 100vw;
  max-width: 800px;
  margin: 10px auto;
  padding: 10px;
  }
`;

export default InnerList;
